import {
  AfterViewInit,
  Component,
  ContentChildren, ElementRef, EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
  QueryList, ViewChild,
} from '@angular/core';
import { TableCellHeaderComponent } from '../table-cell-header/table-cell-header.component';
import { TableRowComponent } from '../table-row/table-row.component';

@Component({
  selector: 'opac-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements AfterViewInit {
  private colsCount = 1;
  private isHoverable = false;

  /**
   * References table root element
   */
  @ViewChild('table') table!: ElementRef<HTMLElement>;

  /**
   * Gets all table row components
   */
  @ContentChildren(TableRowComponent) tableRows!: QueryList<TableRowComponent>;

  /**
   * Get all table header components and calculate columns based on how many header cells are there
   */
  @ContentChildren(TableCellHeaderComponent, { descendants: true }) set tableHeaderCols(value: QueryList<TableCellHeaderComponent>) {
    this.colsCount = value?.length ?? 0;
  }

  /**
   * Binds column count to css variable to set grid columns by default
   */
  @HostBinding('style.--table-columns-count')
  get styleTableColumns() {
    return this.colsCount;
  }

  /**
   * Determines if table rows should be hoverable
   */
  @Input() set hoverable(value: boolean) {
    this.isHoverable = value;

    if (this.tableRows) {
      this.tableRows.forEach((row) => row.isHoverable = value);
    }
  }

  ngAfterViewInit(): void {
    if (this.tableRows) {
      // Prevent "Expression change after detected" warning just waiting Angular check for content.
      requestAnimationFrame(() => {
        this.tableRows.forEach((row) => row.isHoverable = this.isHoverable);
      });
    }
  }

  handleScroll() {
    // Applies shadow to sticky header if any when scroll is > 0
    this.tableRows.forEach((row) => {
      if (row.sticky) {
        row.isScrolling = this.table.nativeElement.scrollTop > 0;
      }
    });
  }
}
